import { render, staticRenderFns } from "./SupervisorDashboard.vue?vue&type=template&id=4aef6ce1&"
import script from "./SupervisorDashboard.vue?vue&type=script&lang=js&"
export * from "./SupervisorDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports